(function () {
  function closeAll(menu) {
    menu.querySelectorAll(".designer-toggle").forEach(function (btn) {
      var list = btn.nextElementSibling;
      if (!list || !list.classList.contains("designer-categories")) return;
      list.setAttribute("hidden", "");
      btn.setAttribute("aria-expanded", "false");
    });
  }

  function positionList(button, list) {
    var nav = button.closest(".meganav__nav");
    var navRect = nav.getBoundingClientRect();
    var btnRect = button.getBoundingClientRect();
    var left = btnRect.left - navRect.left;
    var top = btnRect.bottom - navRect.top + 4;

    list.style.left = left + "px";
    list.style.top = top + "px";

    // not enough room below: open upwards instead
    var h = list.offsetHeight;
    if (btnRect.bottom + 4 + h > navRect.bottom) {
      list.style.top = Math.max(0, btnRect.top - navRect.top - h - 4) + "px";
    }
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(".meganav__nav .designer-toggle");

    // click elsewhere in the menu closes any open list
    if (!button) {
      var menuArea = event.target.closest(".meganav__nav");
      if (menuArea && !event.target.closest(".designer-categories")) {
        closeAll(menuArea);
      }
      return;
    }

    var list = button.nextElementSibling;
    if (!list || !list.classList.contains("designer-categories")) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var shouldOpen = list.hasAttribute("hidden");
    var menu = button.closest(".meganav__nav");

    closeAll(menu);

    if (shouldOpen) {
      list.removeAttribute("hidden");
      button.setAttribute("aria-expanded", "true");
      positionList(button, list);
    }
  }, true);
})();